export const cardContainer =
  "relative w-full h-full bg-gradient-to-b from-primary-color-light/10 to-primary-color-light/5 rounded-3xl p-px overflow-hidden";
export const gridColumns3 = "grid gap-8 sm:grid-cols-3 md:gap-12";
export const cardPadding = "pl-4";
